module.exports = __webpack_public_path__ + "static/customer-testimonial-bg-2-mobile-6d69a1a9b2e4490487cf8dc4c5bc9506.png";